// extracted by mini-css-extract-plugin
export default {"container":"EL-z","error":"FL-z","disabled":"GL-z","submit":"HL-z","option":"IL-z","success":"JL-z","failure":"KL-z"};